import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useMsal } from '@azure/msal-react';
import { logoutRequest } from './../../authConfig';
import { logoutUser } from '../../store/auth';
import Logo from "../../assets/heartshearinglogowhite.png"
import { inboxSync, getEMRSync } from '../../api/getinboxsync';
import { showLoading, hideLoading } from '../../store/loading-reducer';
import { useNavigate } from 'react-router-dom';
import { RelativeTime } from '../../helpers/formatterHelper';

function Drawer() {
    const dispatch = useDispatch();
    const { instance } = useMsal();
    const navigate = useNavigate();
    // const [loggingOut, setLoggingOut] = useState(false);  
    const { isAdmin } = useSelector((state) => state.auth);
    const [emrSync, SetEMRSync] = useState();
    const [syncMessage, SetSyncMessage] = useState('Successful Sync');
    const handleLogoutRedirect = async () => {
        await dispatch(logoutUser());

        let request = {
            ...logoutRequest,
            account: instance.getActiveAccount()
        };

        await instance.logoutRedirect(request)
            .catch((error) => console.log(error));
    };
    useEffect(() => {
        GetEMRSync();
    }, []);

  
    const InboxSync = () => {
        if (isAdmin) {
            dispatch(showLoading());
            inboxSync().then((response) => {
                if (response) {
                    GetEMRSync();
                    navigate('/inbox');
                }
                dispatch(hideLoading());
            });
        }
    }
    const GetEMRSync = () => {
        getEMRSync().then((response) => {
            if (response.data.success && response.data.data) {

                SetEMRSync(response.data.data);
                SetSyncMessage('Successful Sync');
            }

        });
    }
    //if you want using loginout state
    //useEffect(() => {
    //    if (loggingOut) {
    //        if (instance.getActiveAccount()) {
    //            handleLogoutRedirect();
    //        }
    //    }
    //}, [loggingOut]);

    //useEffect(() => {
    //    dispatch(showLoading());
    //    getLoginUserDetails()
    //        .then((response) => {
    //            setLoginUser(response?.data);
    //            dispatch(delayedHideLoading());
    //        })
    //        .catch(() => {
    //            dispatch(hideLoading());
    //        });
    //}, []);

    // To do later for access permission
    //const adminClaim = loginUser?.data?.userClaims;
    //var isAdminUsersAccess = adminClaim?.filter(x => x.key === 'adminusers')?.length > 0;

    return (

        <>         
            <nav className="admin-drawer-wrap">
                <div className="admin-drawer-main">
                    <div className="admin-drawer-info-wrap">
                        <a className="admin-drawer-info-title decoration" href="/">
                            <img src={Logo} alt="logo" className="logo-image" />
                            Appointment Reminder System
                        </a>
                    </div>
                    <div className="admin-drawer-link-wrap">
                        <a className="admin-drawer-link" href="/compose">
                            <span
                                className="admin-drawer-link-icon material-symbols-rounded"
                                aria-hidden="true"
                            >
                                chat_paste_go
                            </span>
                            <span className="admin-drawer-link-text">Compose</span>
                        </a>

                        <a className="admin-drawer-link" href="/inbox">
                            <span
                                className="admin-drawer-link-icon material-symbols-rounded"
                                aria-hidden="true"
                            >
                                inbox
                            </span>
                            <span className="admin-drawer-link-text">Inbox</span>
                        </a>
                        <a className="admin-drawer-link" href="/sent">
                            <span
                                className="admin-drawer-link-icon material-symbols-rounded"
                                aria-hidden="true"
                            >
                                send
                            </span>
                            <span className="admin-drawer-link-text">Sent</span>
                        </a>

                        <a className="admin-drawer-link" href="/appointments">
                            <span
                                className="admin-drawer-link-icon material-symbols-rounded"
                                aria-hidden="true"
                            >
                                today
                            </span>
                            <span className="admin-drawer-link-text">Appointments</span>
                        </a>

                        <a className="admin-drawer-link" href="/contacts">
                            <span
                                className="admin-drawer-link-icon material-symbols-rounded"
                                aria-hidden="true"
                            >
                                contacts
                            </span>
                            <span className="admin-drawer-link-text">Contacts</span>
                        </a>


                        <a className="admin-drawer-link" href="/setting">
                            <span
                                className="admin-drawer-link-icon material-symbols-rounded"
                                aria-hidden="true"
                            >
                                settings
                            </span>
                            <span className="admin-drawer-link-text">Settings</span>
                        </a>
                        <a className="admin-drawer-link" href="/report">
                            <span
                                className="admin-drawer-link-icon material-symbols-rounded"
                                aria-hidden="true"
                            >
                                table_chart
                            </span>
                            <span className="admin-drawer-link-text">Reports</span>
                        </a>

                        <a className="admin-drawer-link" href="/groups">
                            <span
                                className="admin-drawer-link-icon material-symbols-rounded"
                                aria-hidden="true"
                            >
                                group
                            </span>
                            <span className="admin-drawer-link-text">Saved Groups</span>
                        </a>

                        <a className="admin-drawer-link cursor-pointer" role="button" onClick={() => { handleLogoutRedirect(); }}>
                            <span
                                className="admin-drawer-link-icon material-symbols-rounded"
                                aria-hidden="true"
                            >
                                logout
                            </span>
                            <span className="admin-drawer-link-text">Logout</span>
                        </a>
                    </div>
                    <a className="refresh-status admin-drawer-link cursor-pointer" role="button" onClick={InboxSync}>
                        <span className="material-symbols-rounded w-100">
                            sync
                        </span>
                        {syncMessage}
                        <br />
                        {emrSync && (
                            <span>
                                {<RelativeTime dateStr={emrSync?.syncDate} />}                                
                            </span>
                        )}
                    </a>

                </div>
            </nav>
        </>
    );
}

export default Drawer;
